<template>
  <div class="loverSortBox">
    <div class="spotTabs">
      <el-tabs v-model="spotActive" type="card" @tab-click="handleClick">
        <el-tab-pane label="女款" name="first"> </el-tab-pane>
        <el-tab-pane label="男款" name="second"> </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 女款现货列表 -->
    <div class="custom" v-if="spotActive == 'first'">
      <div class="fx" v-if="goldenWeighList && goldenWeighList.length > 0">
        <div class="title">金重</div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <!-- 表带颜色 -->
      <div class="fx" v-if="bandColorList && bandColorList.length > 0">
        <div class="title">表带颜色</div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.bandColor" size="small" @change="getSizeRange($event, 'bandColor', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in bandColorList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <!-- 备注 -->
      <div class="textareaRemark">
        <div class="title">备注</div>
        <el-input
          :rows="6"
          :maxlength="64"
          type="textarea"
          placeholder="其他要求与说明请在此处备注说明,字符数限制64位"
          v-model="dataFrom.productRemark"
        ></el-input>
      </div>
      <div class="box_detail_input price-wrap">
        <div
          class="price-tips"
          v-if="
            (tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))) ||
            (labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)) ||
            (dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0)
          "
        >
          (预估价格，实际价格请以结算为准)
        </div>
        <div>
          <!-- 结算金额 -->
          <div
            class="box_detail_input marginFx"
            v-if="tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))"
          >
            <div class="input-wrap">结算金额：{{ tradePrice }}</div>
          </div>
          <!-- 标签价格 -->
          <div class="box_detail_input marginFx" v-if="labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)">
            <div class="input-wrap">标签价格：{{ labelPrice }}</div>
          </div>
          <!-- 尊享价 -->
          <div class="box_detail_input marginFx" v-if="dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0">
            <div class="input-wrap">尊享价：{{ dataFrom.exclusivePrice }}</div>
          </div>
        </div>
      </div>
      <!-- 下单件数 -->
      <div class="box_detail_input marginFx">
        <div class="input-wrap">
          <span class="prompt">库存{{ dropDownOptional.stockQuantity || 0 }}件，可选择不同规格</span>
          <span class="prompt placeNum">购买数量：</span>
          <el-input-number
            v-model="dataFrom.quantity"
            :min="dropDownOptional.stockQuantity > 0 ? 1 : 0"
            :max="stockQuantity"
            label="描述文字"
            @change="getSizeRange($event, 'quantity', '女')"
          ></el-input-number>
        </div>
      </div>
    </div>
    <div class="custom" v-if="spotActive == 'second'">
      <!-- 男款现货列表 -->
      <div class="fx" v-if="maleGoldenWeighList && maleGoldenWeighList.length > 0">
        <div class="title">金重</div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleGoldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <!-- 表带颜色 -->
      <div class="fx" v-if="maleBandColorList && maleBandColorList.length > 0">
        <div class="title">表带颜色</div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.bandColor" size="small" @change="getSizeRange($event, 'bandColor', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleBandColorList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <!-- 备注 -->
      <div class="textareaRemark">
        <div class="title">备注</div>
        <el-input
          :rows="6"
          :maxlength="64"
          type="textarea"
          placeholder="其他要求与说明请在此处备注说明,字符数限制64位"
          v-model="maleDataFrom.productRemark"
        ></el-input>
      </div>
      <div class="box_detail_input price-wrap">
        <div
          class="price-tips"
          v-if="
            (maleTradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))) ||
            (malelLabelPrice && (!maleDataFrom.exclusivePrice || maleDataFrom.exclusivePrice == 0)) ||
            (maleDataFrom.exclusivePrice && maleDataFrom.exclusivePrice != 0)
          "
        >
          (预估价格，实际价格请以结算为准)
        </div>
        <div>
          <!-- 结算金额 -->
          <div
            class="box_detail_input marginFx"
            v-if="maleTradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))"
          >
            <div class="input-wrap">结算金额：{{ maleTradePrice }}</div>
          </div>
          <!-- 标签价格 -->
          <div class="box_detail_input marginFx" v-if="malelLabelPrice && (!maleDataFrom.exclusivePrice || maleDataFrom.exclusivePrice == 0)">
            <div class="input-wrap">标签价格：{{ malelLabelPrice }}</div>
          </div>
          <!-- 尊享价 -->
          <div class="box_detail_input marginFx" v-if="maleDataFrom.exclusivePrice && maleDataFrom.exclusivePrice != 0">
            <div class="input-wrap">尊享价：{{ dataFrom.exclusivePrice }}</div>
          </div>
        </div>
      </div>
      <!-- 下单件数 -->
      <div class="box_detail_input marginFx">
        <div class="input-wrap">
          <span class="prompt">库存{{ dropDownOptional.stockQuantity || 0 }}件，可选择不同规格</span>
          <span class="prompt placeNum">购买数量：</span>
          <el-input-number
            v-model="maleDataFrom.quantity"
            :min="dropDownOptional.stockQuantity > 0 ? 1 : 0"
            :max="maleStockQuantity"
            label="描述文字"
            @change="getSizeRange($event, 'quantity', '男')"
          ></el-input-number>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { deepClone } from '@/utils/util';
export default {
  name: '',
  props: {
    DataList: {
      type: Object,
      default() {
        return {};
      },
    },
    leastQuantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      spotActive: 'first',
      dataFrom: {
        styleNumber: this.DataList.styleNumber, // 公司款号
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples, // 是否情侣款
        classify: 3, // 产品结构
        quantity: 0, // 数量
        shopType: 3,
        spotFlag: 1,
        bandColor: '',
        goldWeigh: '',
        productRemark: '',
        gender: '女',
        tradePrice: '', //传给后端
        labelPrice: '', //传给后端
        exclusivePrice: '', //传给后端
      },
      maleDataFrom: {
        styleNumber: this.DataList.styleNumber, // 公司款号
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples, // 是否情侣款
        classify: 3, // 产品结构
        quantity: 0, // 数量
        shopType: 3,
        spotFlag: 1,
        bandColor: '',
        goldWeigh: '',
        productRemark: '',
        gender: '男',
        tradePrice: '', //传给后端
        labelPrice: '', //传给后端
        exclusivePrice: '', //传给后端
      },
      dropDownOptional: {},
      goldenWeighList: [],
      bandColorList: [],
      maleGoldenWeighList: [],
      maleBandColorList: [],
      stockQuantity: 0,
      maleStockQuantity: 0,
      tradePrice: '', //页面展示
      labelPrice: '', //页面展示
      maleTradePrice: '', //页面展示
      malelLabelPrice: '', //页面展示
    };
  },
  mounted() {
    this.dataFrom = { ...this.dataFrom, ...this.DataList };
    this.maleDataFrom = { ...this.maleDataFrom, ...this.DataList };
    this.dataFrom.gender = '女';
    this.maleDataFrom.gender = '男';
    // 获取可选属性
    this.getOptional();
  },
  methods: {
    handleClick(tab) {
      if (tab.name == 'first') {
        this.goldenWeighList = this.mainStoneSort(this.dropDownOptional.couplesMap[this.dataFrom.gender]['goldenWeigh']);
        this.bandColorList = this.dropDownOptional.couplesMap[this.dataFrom.gender]['bandColor'];
        this.fetchPriceRangeSpot('女');
      } else {
        this.maleGoldenWeighList = this.mainStoneSort(this.dropDownOptional.couplesMap[this.maleDataFrom.gender]['goldenWeigh']);
        this.maleBandColorList = this.dropDownOptional.couplesMap[this.maleDataFrom.gender]['bandColor'];
        this.fetchPriceRangeSpot('男');
      }
    },
    // 金重排序
    mainStoneSort(list) {
      // 1. 将每个区间字符串解析为对象
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range }; // 保留原始字符串以便最后恢复
      });
      // 2. 根据 start 值进行排序
      parsedRanges.sort((a, b) => a.start - b.start);
      // 3. 提取排序后的原始字符串
      return parsedRanges.map((item) => item.range);
    },
    // 获取可选属性
    getOptional(text) {
      let obj = {
        styleNumber: this.DataList.styleNumber,
        classify: 3,
        spotFlag: 1,
        gender: '',
      };
      getOptional(obj).then((res) => {
        this.dropDownOptional = { ...this.dropDownOptional, ...res.data };
        this.goldenWeighList = this.mainStoneSort(res.data.couplesMap[this.dataFrom.gender]['goldenWeigh']);
        this.bandColorList = res.data.couplesMap[this.dataFrom.gender]['bandColor'];
        this.$emit('upDataStockQuantity', this.dropDownOptional.stockQuantity);
      });
    },
    getSizeRange(value, type, gender) {
      if (gender === '女') {
        this.dataFrom[type] = value;
      } else {
        this.maleDataFrom[type] = value;
      }
      this.fetchPriceRangeSpot(gender);
    },
    fetchPriceRangeSpot(gender) {
      const obj = gender == '女' ? deepClone(this.dataFrom) : deepClone(this.maleDataFrom);
      delete obj.texture;
      if (!obj.goldWeigh || !obj.bandColor) return;
      getPriceRangeSpot(obj).then((res) => {
        if (gender == '女') {
          this.tradePrice = res.data.tradePrice;
          this.labelPrice = res.data.labelPrice;
          this.dataFrom.tradePrice = res.data.tradePrice;
          this.dataFrom.labelPrice = res.data.labelPrice;
          this.dataFrom.exclusivePrice = res.data.exclusivePrice;
          this.stockQuantity = res.data.stockQuantity;
          if ((!this.dataFrom.quantity || this.dataFrom.quantity == 0) && res.data.stockQuantity > 0) this.dataFrom.quantity = 1;
          if (this.dataFrom.quantity > res.data.stockQuantity || res.data.stockQuantity == 0) {
            this.dataFrom.quantity = res.data.stockQuantity;
          }
        } else {
          this.maleTradePrice = res.data.tradePrice;
          this.malelLabelPrice = res.data.labelPrice;
          this.maleDataFrom.tradePrice = res.data.tradePrice;
          this.maleDataFrom.labelPrice = res.data.labelPrice;
          this.maleDataFrom.exclusivePrice = res.data.exclusivePrice;
          this.maleStockQuantity = res.data.stockQuantity;
          if ((!this.maleDataFrom.quantity || this.maleDataFrom.quantity == 0) && res.data.stockQuantity > 0) this.maleDataFrom.quantity = 1;
          if (this.maleDataFrom.quantity > res.data.stockQuantity || res.data.stockQuantity == 0) {
            this.maleDataFrom.quantity = res.data.stockQuantity;
          }
        }
        this.dropDownOptional.stockQuantity = res.data.stockQuantity;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.loverSortBox {
  margin-bottom: 10px;
  position: relative;

  .spotTabs {
    // width: 230px;
  }

  .spotTabs .el-tabs__nav {
    width: 100%;
  }

  .spotTabs .el-tabs__item {
    // width: 50%;
    text-align: center;
  }

  .spotTabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom: #e4e7ed;
    background: #ec9368;
    color: #fff;
  }

  .spotTabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active:hover {
    color: #fff !important;
  }

  .spotTabs .el-tabs__item:hover {
    color: #ec9368 !important;
  }

  .loverPricesPrompt {
    font-size: 13px;
    color: red;
    position: absolute;
    top: 40px;
    z-index: 1;
  }

  .el-select-dropdown__item {
    margin: 10px 0 0 10px;
    display: inline-block;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border: 1px solid #d3d3d3;
    padding: 0;
    font-size: 16px;
    color: #000;
  }

  .el-select-dropdown__item.selected {
    background: #fff2ea;
    font-size: 16px;
    color: #000;
    font-weight: 400;
    border: 1px solid #ee9c75;
  }
}
.custom {
  .fx {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }
  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .inchesTips {
    color: #ec9368;
  }
  .material {
    width: 800px;
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }
  .title {
    font-size: 18px;
    color: #000;
    display: inline-block;
    margin-bottom: 8px;
    .hidden {
      visibility: hidden;
    }
  }

  .value-font {
    font-size: 18px;
    color: #ec9368;
  }
  .mainStoneClssBoxFx {
    width: 675px;
    display: flex;
    align-items: center;
    position: relative;
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }
  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }
  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }
  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }
  .price-wrap {
    justify-content: flex-end;
  }
  .price-tips {
    color: red;
    margin-right: 10px;
  }
}
</style>
